import { HealthPlanFieldState } from '@/modules/HealthPlan/HealthPlan.types';
import { baseStoreCreator } from '@/utils/store';

export interface HealthPlanNameFieldsStatePayload {
  healthPlanName: HealthPlanFieldState;
  healthPlanStatus: HealthPlanFieldState;
  healthPlanTypes: HealthPlanFieldState;
  carrierName: HealthPlanFieldState;
  carrierId: HealthPlanFieldState;
  autocreateCdhEnrollment: HealthPlanFieldState;
  perPersonSpendLimit: HealthPlanFieldState;
  perCategorySpendLimit: HealthPlanFieldState;
  parentTemplate: HealthPlanFieldState;
  planCode: HealthPlanFieldState;
  plans: HealthPlanFieldState;
}

export const DEFAULT_VALUES: HealthPlanNameFieldsStatePayload = {
  healthPlanName: HealthPlanFieldState.Modifiable,
  healthPlanStatus: HealthPlanFieldState.Modifiable,
  healthPlanTypes: HealthPlanFieldState.Modifiable,
  carrierName: HealthPlanFieldState.Modifiable,
  carrierId: HealthPlanFieldState.Locked,
  autocreateCdhEnrollment: HealthPlanFieldState.Modifiable,
  perPersonSpendLimit: HealthPlanFieldState.Modifiable,
  perCategorySpendLimit: HealthPlanFieldState.Modifiable,
  parentTemplate: HealthPlanFieldState.Locked,
  planCode: HealthPlanFieldState.Modifiable,
  plans: HealthPlanFieldState.Modifiable,
};

export const useStore = baseStoreCreator<HealthPlanNameFieldsStatePayload>(DEFAULT_VALUES);

export default useStore;
